var map = {
	"./activity.js": 17202,
	"./ai.js": 39988,
	"./banner.js": 14572,
	"./bill.js": 27952,
	"./category.js": 22159,
	"./chargeCoupon.js": 75363,
	"./customer_level.js": 17603,
	"./deduct_coupon.js": 10963,
	"./desk.js": 60818,
	"./desk_partition.js": 67700,
	"./holdOrder.js": 88180,
	"./keepAlive.js": 77187,
	"./member.js": 20623,
	"./oem.js": 51005,
	"./offline.js": 39657,
	"./order.js": 66405,
	"./orderPlus.js": 52849,
	"./permission.js": 47560,
	"./prepackaging.js": 82468,
	"./printer_config.js": 92352,
	"./product.js": 83735,
	"./scale.js": 9464,
	"./shifangBridge.js": 19336,
	"./shop.js": 16582,
	"./takeout_order.js": 62553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52645;